module.exports = __webpack_public_path__ + "static/media/laryna.8fa9516b.jpg";